import Contracts from "./contracts";

const ModuleName = "tfApp.options";

export default angular.module(ModuleName, [Contracts(ModuleName)])
                      .name;
